export default "__VITE_ASSET__B6VBk3e2__"